import {useTableContext} from '../TableContext.jsx'
import TopButton from './TopButton.jsx'

const ButtonCreateRows = ({
    children = '新增',
    count = 1,
    beforeCreate = async table => Array.from(new Array(count)).map(() => ({})),
    ...props
}) => {
    const table = useTableContext()

    const handleClick = async () => {
        const {selectedRowKeys = []} = table.rowSelection ?? {}

        if (0 < selectedRowKeys.length) {
            const pairs = await Promise.all(
                selectedRowKeys.map(async key => {
                    const newRows = await beforeCreate(table)
                    return [key, newRows]
                })
            )

            table.insertRowsAfter(pairs)
        }
        else {
            const newRows = await beforeCreate(table)
            table.appendRows(newRows)
        }
    }

    return (
        <TopButton
            onClick={handleClick}
            {...props}
        >{children}</TopButton>
    )
}

export default ButtonCreateRows
